import React, { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

import { Header } from '../../header';

export const ServiceRedirectPage = () => {
    const [searchParams] = useSearchParams();
    const { status } = useParams();
    const navigate = useNavigate();

    const id = searchParams.get("order_id");

    useEffect(() => {
        setTimeout(() => {
            navigate(`/payment/${id}`)
        }, 5000);
    })

    return (
        <section className="w-full h-screen bg-white">

            <Header page="merch" />

            <div className="w-full h-full flex flex-col justify-center items-center">

                <div className="flex flex-col justify-center items-center">
                    <p className={`font-lack text-6xl ${status === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                        {`${status === 'success' ? 'Оплата прошла успешно' : 'Не удалось оплатить заказ'}`}
                    </p>
                    <p className="mt-4 text-xl text-center">
                        Редиректим на страницу заказа через 5 секунд...
                    </p>
                    <p className="text-xl text-center text-blue-800">
                        Нажми сюда, если это не произошло автоматически
                    </p>
                </div>

            </div>

        </section>
    )

};
